import { MouseEvent } from 'react'
import {useSelector} from "react-redux";
import {State} from "../../../../../state";

interface EllipseDrawingViewProps {
    width: number
    height: number
    left: number
    top: number
    onClick: () => void
    onMouseDown: (event: MouseEvent) => void
    visible: boolean
    selected: boolean
}

export const EllipseDrawingView = (props: EllipseDrawingViewProps) => {
    const {tool} = useSelector((state: State) => state.editor)

    var circleStyle = {
        padding: 0,
        margin: 0,
        display: 'inline-block',
        borderRadius: '50%',
        backgroundColor: props.selected ? 'red' :'white',
        width: props.width,
        height: props.height,
        left: props.left - props.width / 2,
        top: props.top - props.height / 2,
    }

    return <div onMouseDown={props.onMouseDown} onClick={props.onClick} style={{ position: 'absolute', visibility: !props.visible ? `hidden` : `visible`, pointerEvents: tool === null ? 'all' : 'unset', ...circleStyle }}></div>
}
